import React from 'react';
import { connect } from 'redux-zero/react';

import { actions } from '../../shared/store.js';

import './loading.scss';

const Loading = () => (
	<div className="wrapper-loader">
		<div className="loading">
			<div className="circle circle-1" />
			<div className="circle circle-2" />
			<div className="circle circle-3" />
			<div className="circle circle-4" />
		</div>
	</div>
);

const mapToProps = ({ language, seeker, isLoading }) => ({
	language,
	seeker,
	isLoading,
});

const CustomLoadableLoading = connect(
	mapToProps,
	actions,
)(
	class CustomLoadableLoadingInternal extends React.Component {
		constructor(props) {
			super(props);

			props.setLoading(true);
		}

		render() {
			return null;
		}
	},
);

export default Loading;

export { CustomLoadableLoading };
